import React from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "../styles/RangeInput.css";

export default props => {
  return (
    <div className="range-input">
      <Slider
        min={props.min || 1}
        max={props.max || 50}
        value={props.value}
        className="range-input"
        onChange={props.onChanged}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/elements/RangeInput.js